import { Component, Input, Output, inject } from "@angular/core";
import { FormBuilder, FormControl, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ConfigurationWizardHeaderComponent } from "@components/configuration-wizard-header/configuration-wizard-header.component";
import { Product } from "@domain/product/product";
import { defer, map, of } from "rxjs";

export interface PlasticSignSpecs {
  text?: string;
  backgroundColor?: string;
  textColor?: string;
}

interface PlasticSignProducts {
  selectedPlasticSign: Product;
  preselectedSpecs?: PlasticSignSpecs;
}

@Component({
  selector: "app-plastic-sign-specs",
  templateUrl: "./plastic-sign-specs.component.html",
  styleUrls: ["./plastic-sign-specs.component.scss"],
  imports: [UiKitModule, ReactiveFormsModule, ConfigurationWizardHeaderComponent],
})
export class PlasticSignSpecsComponent {
  private formBuilder = inject(FormBuilder);

  @Input({ required: true }) showCosts!: boolean;

  @Input({ required: true }) set selectedProduct(product: PlasticSignProducts) {
    this.specsForm.patchValue({ text: null, backgroundColor: null, textColor: null });
    this.selectedPlasticSign = product.selectedPlasticSign;
    if (product.preselectedSpecs) {
      this.specsForm.patchValue({
        text: product.preselectedSpecs.text,
        backgroundColor: product.preselectedSpecs.backgroundColor,
        textColor: product.preselectedSpecs.textColor,
      });
    }
  }

  protected specsForm = this.formBuilder.group({
    text: new FormControl<null | string>(null),
    backgroundColor: new FormControl<null | string>(null),
    textColor: new FormControl<null | string>(null),
  });

  @Output() formReady = of(this.specsForm);

  @Output() specs$ = defer(() =>
    this.specsForm.valueChanges.pipe(
      map((formValue) =>
        formValue.text || formValue.textColor || formValue.backgroundColor ? (formValue as PlasticSignSpecs) : undefined,
      ),
    ),
  );

  protected selectedPlasticSign!: Product;
}
